"use client";

import { useRouter } from "next/navigation";
import { useUser } from "../../hooks/useUser";
import { Button } from "../Actions/Button";
import { truncateWalletAddress } from "@/utils/web3/truncateWalletAddress";

export const LoginButton: React.FC = () => {
  const { login, user, authenticated, logout } = useUser();
  const router = useRouter();

  if (authenticated)
    return (
      <div className="flex gap-2">
        <Button
          modifier="tertiary"
          onClick={() => router.push("/coop/onboarding")}
          type="button">
          {truncateWalletAddress(user?.wallet?.address)}
        </Button>
        <Button modifier="secondary" onClick={logout}>
          Logout
        </Button>
      </div>
    );

  return (
    <Button modifier="primary" onClick={() => login()}>
      Connect Wallet
    </Button>
  );
};
